<div class="review-dialog">
    <div class="dialog-header one-row">
        <h2>{{ data.mode === 'edit' ? 'Sonstigen Erlös bearbeiten' : 'Sonstigen Erlös abgleichen' }}</h2>
        <span class="spacer"></span>
        <button mat-icon-button type="button" (click)="prevPage()" [disabled]="page <= 1" matTooltip="Vorherige Seite">
            <mat-icon>navigate_before</mat-icon>
        </button>
        <span class="page-label">{{ page }} / {{ totalPages || '…' }}</span>
        <button
            mat-icon-button
            type="button"
            (click)="nextPage()"
            [disabled]="!totalPages || page >= totalPages"
            matTooltip="Nächste Seite"
        >
            <mat-icon>navigate_next</mat-icon>
        </button>
        <button mat-icon-button type="button" (click)="close()" matTooltip="Schließen">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <div class="review-body">
        <div class="pdf-pane" #pdfPane>
            <div class="pdf-loading" *ngIf="pdfLoading && data?.pdfFile">PDF wird geladen …</div>
            <pdf-viewer
                *ngIf="pdfSrc"
                [src]="pdfSrc"
                [page]="page"
                [show-all]="false"
                [render-text]="true"
                [original-size]="false"
                [fit-to-page]="false"
                [autoresize]="true"
                [zoom-scale]="'page-width'"
                (after-load-complete)="onPdfLoad($event)"
                (error)="onPdfError($event)"
            ></pdf-viewer>
            <div class="pdf-missing" *ngIf="!pdfSrc && !pdfLoading">
                <mat-icon>picture_as_pdf</mat-icon>
                <p>{{ data.mode === 'edit' ? 'Kein PDF hinterlegt.' : 'PDF fehlt – Review trotzdem möglich.' }}</p>
            </div>
            <div class="pdf-toolbar" *ngIf="pdfSrc || data?.pdfFile">
                <button
                    mat-stroked-button
                    type="button"
                    (click)="reloadPdf()"
                    [disabled]="!data?.pdfFile || pdfLoading"
                    matTooltip="PDF-Viewer neu laden"
                >
                    <mat-icon>refresh</mat-icon>
                    PDF neu laden
                </button>
                <button
                    mat-stroked-button
                    type="button"
                    color="primary"
                    (click)="openPdfInNewTab()"
                    matTooltip="PDF in neuem Tab öffnen"
                >
                    <mat-icon>open_in_new</mat-icon>
                    PDF öffnen
                </button>
            </div>
        </div>

        <div class="form-pane">
            <p class="meta" *ngIf="data?.draft?.extract?.source">
                Quelle: {{ data.draft.extract.source }}
                <span *ngIf="data.draft.extract.overallConfidence != null">
                    · Confidence {{ (data.draft.extract.overallConfidence * 100) | number: '1.0-0' }}%
                </span>
            </p>
            <p class="meta extract-totals" *ngIf="extractNetto != null || extractBrutto != null">
                Extrakt-Gesamt:
                <span *ngIf="extractNetto != null">Netto {{ extractNetto | number: '1.2-2' }} €</span>
                <span *ngIf="extractNetto != null && extractBrutto != null"> · </span>
                <span *ngIf="extractBrutto != null">Brutto {{ extractBrutto | number: '1.2-2' }} €</span>
            </p>

            <div class="warnings" *ngIf="warnings?.length">
                <div *ngFor="let w of warnings">{{ w }}</div>
            </div>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Partner</mat-label>
                    <mat-select [(ngModel)]="partnerArt" (selectionChange)="onPartnerArtChange()">
                        <mat-option value="INSTITUTION">Institution</mat-option>
                        <mat-option value="DEBITOR">Sonstiger Kunde</mat-option>
                    </mat-select>
                </mat-form-field>
            </div>
            <kiene-autocomplete
                *ngIf="partnerArt === 'INSTITUTION'"
                [apiUrl]="'institution/'"
                [displayFields]="['bezeichnung']"
                [focus]="false"
                [kieneObject]="institution"
                [params]="aktivParams"
                [placeholder]="'Institution (TSK/Kammer)'"
                [required]="true"
                (elementSelected)="onInstitutionSelected($event)"
            ></kiene-autocomplete>
            <kiene-autocomplete
                *ngIf="partnerArt === 'DEBITOR'"
                [apiUrl]="'sonstiger_debitor/'"
                [displayFields]="['bezeichnung']"
                [focus]="false"
                [kieneObject]="debitor"
                [params]="aktivParams"
                [placeholder]="'Sonstiger Kunde'"
                [required]="true"
                (elementSelected)="onDebitorSelected($event)"
            ></kiene-autocomplete>

            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Belegnr</mat-label>
                    <input [formControl]="belegnrCtrl" matInput />
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Datum</mat-label>
                    <input [formControl]="datumCtrl" [matDatepicker]="picker" matInput required />
                    <mat-datepicker-toggle [for]="picker" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                </mat-form-field>
            </div>
            <div class="one-row">
                <mat-form-field style="width: 48%">
                    <mat-label>Leistung von</mat-label>
                    <input [formControl]="leistVonCtrl" [matDatepicker]="dv" matInput />
                    <mat-datepicker-toggle [for]="dv" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #dv></mat-datepicker>
                </mat-form-field>
                <mat-form-field style="width: 48%">
                    <mat-label>Leistung bis</mat-label>
                    <input [formControl]="leistBisCtrl" [matDatepicker]="db" matInput />
                    <mat-datepicker-toggle [for]="db" matSuffix></mat-datepicker-toggle>
                    <mat-datepicker #db></mat-datepicker>
                </mat-form-field>
            </div>

            <h3>Steuerzeilen (Default 0 %)</h3>
            <div class="preis-row" *ngFor="let p of preise; let i = index">
                <mat-form-field class="field-text">
                    <mat-label>Bezeichnung</mat-label>
                    <input [(ngModel)]="p.bezeichnung" matInput />
                </mat-form-field>
                <mat-form-field class="field-num-wide">
                    <mat-label>Netto</mat-label>
                    <input [(ngModel)]="p.kosten_netto" matInput type="number" step="0.01" />
                    <span matSuffix>&euro;</span>
                </mat-form-field>
                <mat-form-field class="field-mwst">
                    <mat-label>MwSt</mat-label>
                    <mat-select [(ngModel)]="p.mwstsatz">
                        <mat-option *ngFor="let m of mwstSaetze" [value]="m">{{ m }} %</mat-option>
                    </mat-select>
                </mat-form-field>
                <kiene-autocomplete
                    [apiUrl]="'fibu_konto/'"
                    [displayFields]="['konto_nr', 'bezeichnung']"
                    [focus]="false"
                    [kieneObject]="p.erloes"
                    [params]="erloesParams"
                    [placeholder]="'86xx'"
                    (elementSelected)="p.erloes = $event"
                ></kiene-autocomplete>
                <button mat-icon-button type="button" (click)="removePreis(i)" [disabled]="preise.length < 2">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <button mat-stroked-button type="button" (click)="addPreis()">Zeile hinzufügen</button>

            <mat-form-field style="width: 100%; margin-top: 12px">
                <mat-label>Kommentar</mat-label>
                <textarea [formControl]="kommentarCtrl" matInput rows="2"></textarea>
            </mat-form-field>
            <mat-checkbox [formControl]="freigegebenCtrl">Freigeben (Journal)</mat-checkbox>

            <div class="actions">
                <span class="actions-spacer"></span>
                <button mat-button type="button" (click)="close()">Abbrechen</button>
                <button
                    mat-flat-button
                    color="accent"
                    type="button"
                    [disabled]="saving || !isValid()"
                    (click)="save()"
                >
                    Speichern
                </button>
            </div>
        </div>
    </div>
</div>
